import { HttpClient } from '@angular/common/http'
import { EventEmitter, inject, Injectable, signal } from '@angular/core'
import { ShopRepository } from '../../shop.repository'

@Injectable({ providedIn: 'root' })
export abstract class AdRewardService {
	protected readonly shopRepository = inject(ShopRepository)
	private readonly http = inject(HttpClient)

	adrewardStarted$ = new EventEmitter()
	adrewardCredited$ = new EventEmitter()

	showRewardedAd = signal(false)
	videoIsPaused = signal(false)
	hasError = signal(false)
	adAvailable = signal(false)

	abstract requestAd(): Promise<boolean>

	protected creditAdReward() {
		this.adrewardCredited$.emit()
		this.http.post<number>(`@api/bank/credit-video-reward`, {}).subscribe((rewardedVideos) => {
			this.shopRepository.setRewardedVideos(rewardedVideos)
		})
	}

	abstract stopAd(): void

	abstract playAd(): void

	abstract resumeAd(): void
}
